import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { useLocation, Location } from "react-router-dom";

interface NavigationHistoryContextType {
  previousLocation: Location | null;
}

const NavigationHistoryContext = createContext<NavigationHistoryContextType>({
  previousLocation: null,
});

export const useNavigationHistory = () => useContext(NavigationHistoryContext);

interface NavigationHistoryProviderProps {
  children: ReactNode;
}

export const NavigationHistoryProvider = ({
  children,
}: NavigationHistoryProviderProps) => {
  const location = useLocation();
  const [previousLocation, setPreviousLocation] = useState<Location | null>(
    null,
  );
  const [currentLocation, setCurrentLocation] = useState<Location>(location);

  useEffect(() => {
    // Only update if location actually changed (pathname, search, hash, or state)
    if (
      location.pathname !== currentLocation.pathname ||
      location.search !== currentLocation.search ||
      location.hash !== currentLocation.hash ||
      location.key !== currentLocation.key
    ) {
      setPreviousLocation(currentLocation);
      setCurrentLocation(location);
    }
  }, [location, currentLocation]);

  return (
    <NavigationHistoryContext.Provider value={{ previousLocation }}>
      {children}
    </NavigationHistoryContext.Provider>
  );
};
